import { Controller } from "@hotwired/stimulus"

// Modal de edición de temáticas (TC-134-1.3.1.5, US-134-1.3.1).
//
// El custom element `dialog-modal` ya trae el comportamiento del diálogo —abrir,
// cerrar con Escape, cerrar al pulsar fuera, foco atrapado, bloqueo del cuerpo—,
// así que este controlador solo añade lo que es de ESTE modal y no de cualquiera:
// que cerrar sin guardar no deje cambios pendientes en las casillas.
//
// Por qué hace falta. Las casillas llegan marcadas desde el servidor con lo que la
// persona tiene suscrito. Si desmarca "Bolsa", se arrepiente y cierra, el DOM se
// queda con "Bolsa" desmarcada: volver a abrir el modal enseñaría una selección
// que no es la guardada, y bastaría con pulsar "Guardar cambios" para dar de baja
// algo que nadie pidió retirar. `reset()` devuelve cada casilla a su atributo
// `checked` original, que es exactamente el estado persistido.
//
// Cancelar NO envía nada: es la definición de cancelar, y por eso el botón es
// `type="button"` en el HTML y no un `submit` con un parámetro que el servidor
// tendría que interpretar.
export default class extends Controller {
  static targets = ["formulario"]

  // Aspa y "Cancelar". Cierran por la puerta pública del componente, que es la que
  // devuelve el foco al elemento que abrió el modal.
  cierra () {
    this.restaura()
    this.element.close()
  }

  // Escape y clic fuera. El componente los emite como `dialog-modal:dismiss` en vez
  // de obligar a reconocer cada camino por separado, así que aquí se escucha uno
  // solo y no hay forma de que un cierre se quede sin restaurar.
  restaura () {
    this.formularioTarget.reset()
  }
}
